export default "__VITE_ASSET__CihPJ80A__"